import { render, staticRenderFns } from "./DialogAddNews.vue?vue&type=template&id=8e57d6f4&scoped=true&"
import script from "./DialogAddNews.vue?vue&type=script&lang=js&"
export * from "./DialogAddNews.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddNews.vue?vue&type=style&index=0&id=8e57d6f4&lang=scss&scoped=true&"
import style1 from "./DialogAddNews.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e57d6f4",
  null
  
)

export default component.exports